import PropTypes from 'prop-types';
import React, { useState } from 'react';
import toastr from 'toastr';
import { Button } from '@src/components/ui/button/button';

export const FavoriteToggle = ({ itemDetails = {}, onFavorited, className, ...props }) => {
    const [isFavorited, setIsFavorited] = useState(itemDetails.isFavorited);
    const [wishlistId, setWishlistId] = useState(itemDetails.wishlistId);

    const handleSuccess = response => {
        if (!response.success) {
            toastr.error('Please try again later.', 'Oops! Something went wrong.');
        } else {
            if (response.item?.id) {
                setWishlistId(response.item.wishlistId);
            }

            setIsFavorited(prev => !prev);

            if (onFavorited) {
                onFavorited();
            }
        }
    };

    const handleFavoriteClick = event => {
        event.preventDefault();
        event.stopPropagation();

        if (isFavorited) {
            if (props.delFavoriteWishlist) {
                props.delFavoriteWishlist(
                    {
                        userID: props.user.ID,
                        wishlistId: wishlistId
                    },
                    handleSuccess
                );
            }
        } else if (props.setFavoriteWishlist) {
            props.setFavoriteWishlist(
                {
                    ItemDetail: {
                        ID: itemDetails.id
                    }
                },
                handleSuccess
            );
        }
    };

    return (
        <Button
            variant='text'
            className='tw-px-0 tw-min-w-min tw-aspect-square tw-rounded-full'
            onClick={handleFavoriteClick}
        >
            <img src={`/assets/images/${isFavorited ? 'heart-red-btn.svg' : 'heart-btn.svg'}`} alt='heart-btn' />
        </Button>
    );
};

FavoriteToggle.propTypes = {
    itemDetails: PropTypes.shape({
        isFavorited: PropTypes.bool,
        wishlistId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    }),
    onFavorited: PropTypes.func,
    delFavoriteWishlist: PropTypes.func,
    setFavoriteWishlist: PropTypes.func,
    user: PropTypes.shape({
        ID: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    }),
    className: PropTypes.string
};
